import {httpService} from '@epf/shared/http-service';

export const actions = {
    setFilterState: ({dispatch}, {filterName, value}) => {
        dispatch('setFilterStates', {
            filterStates: [
                {filterName: filterName, value: value}
            ]
        });
    },

    setFilterStates: ({commit, state}, {filterStates}) => {
        if (!state.freeze) {
            if (Array.isArray(filterStates)) {
                filterStates.forEach(state => commit('setFilterStateValue', {filterName: state.filterName, value: state.value}))
            }
            // window.location.hash = encodeURI(helper.generateHash(getters.selectedFilters));

            // // Tracking "interaction" with product finder
            // if (typeof window.gtag === 'function') {
            //     window.gtag('event', 'Interaktion', {
            //         'event_category': 'Produkt-Finder',
            //         'event_label': 'add ' + filterName + ': ' + value
            //     });
            // }

            commit('setFreeze', true);
            httpService.fetchResults(state)
                .then(data => {
                    commit('setFreeze', false);
                    commit('setResults', data.entities);
                    commit('setAvailableFilterValues', data.available);
                    commit('setTotal', data.total);
                });
        }
    },
    loadMoreResults: ({commit, state}) => {
        if (!state.freeze) {
            commit('setFreeze', 'no-overlay');
            // history.replaceState({}, '', window.location.pathname+'#'+encodeURI(helper.generateHash(getters.selectedFilters))+'#'+state.results.length);
            httpService.fetchResults(state, state.results.length)
                .then(data => {
                    commit('setFreeze', false);
                    commit('appendResults', data.entities);
                });
        }
    },

    toggleFilters: ({commit}) => {
        commit('toggleFilters');
    }
};
